import React from 'react'
import { Base } from '@crossfit/ui'

import style from './style.module.css'
import { trackEvent } from 'services/segment'
import { Unit } from 'pages/Programming/components/UnitPreference'
import { useSelector } from 'react-redux'
import { getMyAffiliates } from 'store/selectors'

type Props = React.ComponentProps<typeof Base> & {
  options: string[]
  selectedOption: number
}

function ToggleSwitch({ options, selectedOption, onClick, ...props }: Props) {
  const { selectedAffiliate } = useSelector(getMyAffiliates)
  return (
    <Base
      as='button'
      className={style.wrapper}
      aria-pressed={selectedOption === 1 ? `true` : `false`}
      onClick={() => {
        trackEvent({
          component: 'Toggle Switch',
          event: 'Programming Units Toggled',
          location: 'Affiliate Toolkit',
          text: selectedOption === Unit.Imperial ? 'Metric' : 'Imperial',
          affiliateId: selectedAffiliate?.affiliateId,
          userRole:
            selectedAffiliate?.roles?.length > 0
              ? selectedAffiliate?.roles[0]
              : null,
          groupId: selectedAffiliate?.groupId,
        })

        onClick()
      }}
      {...props}
    >
      {options.map((option) => (
        <div className={style.option} key={option}>
          {option}
          <div className={style.highlightedOption}>{option}</div>
        </div>
      ))}
    </Base>
  )
}

export default ToggleSwitch
